import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePicker = ({ label, value, onChange, error, required }) => {
  return (
    <div>
      {label && (
        <label className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <ReactDatePicker
        selected={value}
        onChange={onChange}
        className={`form-control ${error ? "is-invalid" : ""}`}
        dateFormat="MM/dd/yyyy"
        placeholderText="MM/DD/YYYY"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        maxDate={new Date()}
        dayClassName={(date) =>
          date > new Date() ? "react-datepicker__day--future" : ""
        }
      />

      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default DatePicker;
